export const UPDATE_USAGE_SETTING = "UPDATE_USAGE_SETTING";

export function updateUsageSetting(payload) {
  return {
    type: UPDATE_USAGE_SETTING,
    payload: payload,
  };
}
